import { render, staticRenderFns } from "./Form5StyleOfProceeding.vue?vue&type=template&id=b425f554&scoped=true"
import script from "./Form5StyleOfProceeding.vue?vue&type=script&lang=ts"
export * from "./Form5StyleOfProceeding.vue?vue&type=script&lang=ts"
import style0 from "./Form5StyleOfProceeding.vue?vue&type=style&index=0&id=b425f554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b425f554",
  null
  
)

export default component.exports